<template>
  <article ref="textEl" class="text_container">
    <div
      v-for="(view, index) in views"
      :key="index"
      :ref="'el' + index"
      class="text_block"
    >
      <div
        class="share_container"
        v-if="popup == index"
        :class="{ active: popup == index }"
      >
        <a
          class="share_button twitter"
          target="_blank"
          @click="getSocialLink('twitter')"
        ></a>
        <a
          class="share_button facebook"
          target="_blank"
          @click="getSocialLink('facebook')"
        ></a>
      </div>
      <h1 v-if="view.type == 'title'" :id="getAnchor(view.content)">{{view.content}}</h1>
      <p v-if="view.type == 'text' && !Array.isArray(view.content)" v-html="view.content"></p>
      <div v-if="view.type == 'video'" class="video">
        <vue-plyr v-if="view.vimeo">
           <div data-plyr-provider="vimeo" :data-plyr-embed-id="view.vimeo"></div>
        </vue-plyr>
        <vue-plyr v-if="view.youtube">
            <div data-plyr-provider="youtube" :data-plyr-embed-id="view.youtube"></div>
        </vue-plyr>

      </div>

      <div v-if="view.type == 'cards'" class="cards">
        <cards :view="view" :items="view.content" />
      </div>

      <div v-if="view.type == 'list'" class="list">
        <list :view="view" />
      </div>

   <masonry
  :cols="3"
  v-if="view.type == 'gallery'" class="gallery"
  :gutter="20">
        <img v-preview:scope-a v-for="(item, index) in view.content" v-lazy="item.url" :alt="item.caption" :key="index" />
      </masonry>

      <div class="py-4 box" v-if="view.type == 'view' && Array.isArray(view.content)" style="width: 140%; margin-left: -20%; columns: 3;">
        <div style="display: inline-flex; width: 97%;   break-inside: avoid;" class="w-full items-center flex-col mx-auto justify-center rounded-lg border text-center px-6 mb-8 border-b py-4" v-for="(item, index) in view.content" :key="index" v-html="item"></div>
      </div>

    </div>


  </article>
</template>

<script>
import moment from "moment";
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import createPreviewDirective from "vue-photoswipe-directive";
import cards from "@/components/views/cards.vue";
import list from "@/components/views/list.vue";

export default {
  name: "Sidebar",
  components: {
    cards,
    list
  },
  directives: {
    preview: createPreviewDirective(null, PhotoSwipe, PhotoSwipeUI)
  },
  data() {
    return {
      selectedText: null,
      quote: null,
      selected: null,
      isOpen: false,
      array: ["one dkslalskdm kmklsmak", "two", "three"],
      quoteIndex: null,
      popup: null,
      comment: {
        id: null,
        text: null,
      },
    };
  },
  props: ["data", "views", "json", "text", "comments"],
  methods: {
    getAnchor(text) {
      return text.toLowerCase().replace(/ /g, '-')
    },
    onInput(e) {
      if (e.target.innerText.includes('/')) {
          this.isOpen = true
      } else {
        this.isOpen = false
      }
    
    },
    resetComment() {
      this.comment = {
        id: null,
        text: null,
      };
    },
    reply() {
      if (this.account && this.comment.text) {
        this.postReply();
      }
      if (this.account && !this.comment.text) {
        this.error = "Fill in the comment box to reply";
      }
    },
    reload() {
      var link =
        "https://live.edgeryders.eu/paper/" +
        this.id +
        "?quote=" +
        this.quoteIndex;
      window.location.href = link;
    },
    getSocialLink(type) {
      var link =
        "https://live.edgeryders.eu/paper/" +
        this.id +
        "?quote=" +
        this.quoteIndex;
      var social_link = null;
      if (type == "twitter") {
        social_link = "https://twitter.com/intent/tweet?url=" + link;
        window.open(
          social_link,
          "_blank",
          "location=yes,height=570,width=520,scrollbars=no,status=yes"
        );
      }
      if (type == "facebook") {
        social_link = "https://www.facebook.com/sharer/sharer.php?u=" + link;
        window.open(
          social_link,
          "_blank",
          "location=yes,height=570,width=520,scrollbars=no,status=yes"
        );
      }

      if (type == "raw") {
        return link;
      }
    },
    testFunction(ref) {
      var selected = window.getSelection().toString();
      this.selectedText = selected;

      if (selected.length) {
        this.popup = ref;
        var start = this.text.indexOf(selected);
        var end = start + selected.length;
        this.getQuote(start, end);
      } else {
        this.popup = null;
      }
    },
    postReply() {
      var payload = {
        raw: this.comment.text,
        topic_id: this.id,
        reply_to_post_number: this.comment.id,
      };

      var payload_json = JSON.stringify(payload);

      fetch("https://edgeryders.eu/posts.json", {
        method: "post",
        headers: {
          "User-Api-Key": this.apikey.key,
          "Content-Type": "application/json",
        },
        body: payload_json,
      })
        .then((response) => response.json())
        .then((data) => {
          this.post_url =
            "https://edgeryders.eu/t/" + data.topic_id + "/" + data.post_number;
          var obj = {
            text: this.comment.text,
            date: data.created_at,
            id: data.post_number,
            username: this.account.username,
            quote: null,
            avatar_template:
              "https://edgeryders.eu" +
              this.account.avatar_template.replace("{size}", 200),
            reply_to: this.comment.id,
          };
          this.comments.push(obj);
          this.resetComment();
        })
        .catch((error) => console.error(error));
    },
    addComment(id) {
      var obj = {
        id: null,
        text: null,
      };
      if (this.comment.id == id) {
        this.comment = obj;
      } else {
        obj["id"] = id;
        this.comment = obj;

        this.$nextTick(() => {
          var refId = "comment-" + id;
          this.$refs[refId][0].focus();
        });
      }
    },
    filterText(text) {
      function containsAny(str, substrings) {
        for (var i = 0; i != substrings.length; i++) {
          var substring = substrings[i] && substrings[i].quote;
          if (str.indexOf(substring) != -1) {
            return i;
          }
        }
        return null;
      }

      var result = containsAny(text, this.comments);

      var quote = this.comments[result] && this.comments[result].quote;

      var obj = {};

      if (result !== null) {
        (obj["text"] =
          "<div class='comment'>" +
          text.replace(quote, `<span class='highlight'> ${quote} </span>`) +
          "</div>"),
          (obj["comment"] = this.comments[result]);
        return obj;
      } else {
        obj["text"] = text;
        return obj;
      }
    },
    getAvatar(data) {
      return "https://edgeryders.eu" + data.replace("{size}", 200);
    },
    getName(data) {
      return data.name || "@" + data.username;
    },
    getProfile(data) {
      return "https://edgeryders.eu/u/" + data.username;
    },
    getReplies(id) {
      return this.comments.filter((x) => x.reply_to == id);
    },
    getQuote(start, end) {
      this.quote = this.text.substring(start, end);
      this.quoteIndex = start + "," + end;
      this.image_url =
        "https://og-image-main-2.vercel.app/" +
        encodeURI(this.quote) +
        "?images=" +
        this.data.avatar +
        "&widths=" +
        this.data.name +
        "&heights=@" +
        this.data.username;

      var ImageObject = new Image();
      ImageObject.src = this.imageUrl;

      fetch(this.imageUrl).then((response) => console.log(response));
    },
  },
  mounted() {},
  filters: {
    formatDate: function(value) {
      return moment(String(value)).format("dddd, MMMM Do YYYY");
    },
    formatTime: function(value) {
      return moment(String(value)).format("hh:mm A");
    },
  },
  created() {},
};
</script>
<style lang="scss">

:root {
  --plyr-color-main: #008c4f !important; /* Not changing the color */
}

.text_container {
  h1,
  h2,
  h3 {
    @apply text-xl font-bold mb-4;
  }
  h1 {
    @apply text-2xl;
  }

  p {
    @apply mb-4 text-xl;
  }
  a {
    @apply font-bold underline;
  }
  ul,
  ol {
    @apply pl-6 my-2 py-2 pb-0 text-xl pr-20;
    li {
      @apply mb-4;
    }
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: square;
  }
}

.text_block {
  ul {
    list-style: disc;
  }
  li {
   @apply mb-4;
   list-style: disc;
  }
}


.share_container {
  position: absolute;
  left: -100px;
  .share_button {
    opacity: 0;
    width: 35px;
    border-radius: 100px;
    height: 35px;
    background: black;
    display: inline-block;
    @apply mr-2 float-left;
    transform: translateY(30px);
    transition: all 1s ease;
    &:hover {
      cursor: pointer;
    }
    &.twitter {
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='244.2' width='300'%3E%3Cpath d='M95 243A173 173 0 00269 61c11-8 22-19 30-31-11 5-23 8-35 9 13-7 22-19 27-34-12 7-25 13-39 15a61 61 0 00-104 56C97 74 52 49 22 12a61 61 0 0019 82c-10 0-20-3-28-8v1c0 30 21 54 49 60a61 61 0 01-28 1c8 24 31 42 58 42a123 123 0 01-91 26c27 17 59 27 94 27' fill='%23fff'/%3E%3C/svg%3E")
        #1da1f2 no-repeat;
      background-size: 50% !important;
      background-position: center 55% !important;
    }
    &.facebook {
      background: url("data:image/svg+xml,%3Csvg aria-hidden='true' data-prefix='fab' data-icon='facebook-f' class='svg-inline--fa fa-facebook-f fa-w-10' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'%3E%3Cpath fill='%23fff' d='M279 288l14-93h-89v-60c0-25 13-50 53-50h40V6s-37-6-72-6c-73 0-121 44-121 125v70H23v93h81v224h100V288z'/%3E%3C/svg%3E")
        #4767aa no-repeat;
      background-size: 29% !important;
      background-position: 48% 52% !important;
    }
  }
  &.active {
    .share_button {
      opacity: 1;
      transform: translateY(0px);
    }
  }
}

.popover_list {
  @apply rounded-lg overflow-hidden border mr-10 shadow-xl bg-white;
  width: 200px;
  margin-left: -220px;
  li {
    @apply border-b px-4 py-3 font-bold;
    font-size: 14px;
    &:last-child {
      border: none;
    }
  }
}

.commented {
  border-left: 4px solid #efefef;
  padding-left: 20px;
  margin-left: -20px;
  position: relative;
  .comment_container {
    position: absolute;
    left: -340px;
    width: 300px;
    height: 100%;
  }
  .replies {
    .comment_entry {
      border-top: none;
    }
  }
  .comment_entry {
    padding: 12px;
    border-top: 0.5px solid #efefef;
    border-bottom: 0.5px solid #efefef;
    height: auto;
    width: 100%;

    font-size: 14px;

    img {
      border-radius: 6px;
      width: 26px;
      height: 26px;
    }
    .user {
      @apply mb-2 font-bold  flex items-center w-full;
    }
  }
  .error_message {
    background: rgba(255, 71, 27, 0.8);
    padding: 0.5rem 0.65rem;
    font-size: 11px;
    margin: 0.5rem 0 0.75rem;
    font-weight: bold;
    color: white;
  }
  .add_comment {
    display: flex;
    align-items: center;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
    .add_icon {
      background-image: url("data:image/svg+xml,%3Csvg width='79' height='79' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M39.2 0a39.2 39.2 0 100 78.4 39.2 39.2 0 000-78.4zm0 72.4a33.2 33.2 0 110-66.4 33.2 33.2 0 010 66.4zm12.6-36.2h-9.6V26.1a3 3 0 00-6 0v10.1h-9.6a3 3 0 000 6h9.6v10.1a3 3 0 006 0V42.2h9.6a3 3 0 000-6z' fill='rgb(0, 195, 144)' fill-rule='nonzero'/%3E%3C/svg%3E");
      width: 22px;
      height: 22px;
      background-size: 100% !important;
      transform: translateX(-50%) rotate(0deg);
      margin-left: 50%;
      transition: all 0.4s ease;
      position: relative;
    }
    span {
      opacity: 0;
      white-space: nowrap;
      font-size: 12px;
      @apply font-bold;
      color: rgb(0, 195, 144);
      transition: none;
      margin-left: 30px;
    }
    &.active {
      span {
        margin-left: 8px;
        opacity: 1;
        transition: all 0.3s ease 0.2s;
      }
      .add_icon {
        margin-left: 5%;
        transform: translateX(0%) rotate(90deg);
      }
    }
    &:hover,
    &.active {
      cursor: pointer;
      .add_icon {
        background: none;
        &:after {
          background-size: 100% !important;
          content: "";
          position: absolute;
          top: 0;
          width: 22px;
          height: 22px;
          background-image: url("data:image/svg+xml,%3Csvg width='79' height='79' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M39.2 0a39.2 39.2 0 110 78.4 39.2 39.2 0 010-78.4zm0 23.1a3 3 0 00-3 3v10.1h-9.6a3 3 0 000 6h9.6v10.1a3 3 0 006 0V42.2h9.6a3 3 0 000-6h-9.6V26.1a3 3 0 00-3-3z' fill='rgb(0, 195, 144)' fill-rule='nonzero'/%3E%3C/svg%3E");
          cursor: pointer;
        }
      }
    }
  }
}

@keyframes slideup {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.comment_input {
  @apply mx-2;
  textarea {
    width: 100%;
    @apply border p-3;
    font-size: 14px;
    height: 150px;
    background: #fff;
    &.active {
      animation: slideup 0.3s ease forwards;
    }
    &:focus {
      outline: none;
      background: #fff;
      border: 1px solid #1ecd97;
    }
  }
  .post_comment {
    display: flex;
    @apply ml-2 mt-1;
    span,
    a {
      font-size: 13px;

      color: rgba(0, 0, 0, 0.4);
      &:hover {
        color: black !important;
        cursor: pointer;
      }
      &.submit {
        @apply mr-2 pr-2 underline;
        color: #1ecd97;
      }
    }
  }
}

.highlight {
  background: #1ecd97;
  padding: 2px 4px;
  display: inline;
  box-decoration-break: clone;
  color: white;
}

.box {
  h2 {
    @apply w-full flex flex-col items-center justify-center border-b pb-3 mb-2;
    img {
      height: 65px;
      width: auto; 
      @apply mb-2;
    }
  }
  p {
    @apply text-lg;
  }
}

.video {
  width: 80%;
  @apply my-6 mx-auto mb-10;
    border-radius: 15px;
  .plyr--video, .plyr__video-wrapper {
    background: white;
    border-radius: 10px;
    overflow: hidden;
  }
}

.gallery {
  @apply my-2 py-6;
  position: relative;
  width: 140%;
  left: -20%;
  img[lazy=loading] {
    background: #efefef;
    @apply rounded-lg bg-gray-200;
  }
  img {
    @apply mb-5 rounded-lg;
    transition: all .35s ease;

    &:hover {
    cursor: pointer;
    transform: scale(1.015);
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
  }
  }

}
.pswp__caption__center {
  @apply font-bold text-lg;
  text-align: center !important;
}


@media only screen and (max-width: 600px) {
.video {
  width: 100%;
  @apply my-3 mb-5;
}
 }
</style>
